module.exports = __webpack_public_path__ + "img/client-2.ce3c13d4.png";